// extracted by css-extract-rspack-plugin
export default {"navigator":"Navi__navigator--WXv6o","body":"Navi__body--plHA5","items":"Navi__items--zC330","item":"Navi__item--rFYeB","submitItem":"Navi__submitItem--htOeT"};